import React, { useEffect, useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Legend, Tooltip, ResponsiveContainer } from "recharts";
import { useNavigate } from 'react-router-dom';
import { useReviewRatingApi } from '../../store/api/hooks/reviewratingApiHook';
import { useAuthStatus, useStoreSelector, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { toast } from 'react-hot-toast';
import moment from 'moment';
import { OverallRatingProps } from '../../_config/interfaces/interfaces';


const OverallRating: React.FC<OverallRatingProps> = ({ filterValue }) => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [ratingSummary, setRatingSummary] = useState<any>({});
    const branchDS = useStoreBrnDSSelector();
    const reviewAPI = useReviewRatingApi();

    useEffect(() => {
        if (filterValue !== null) {
            applyFilter(filterValue); // This is called automatically when filterValue changes
        } else {
            getRatingSummary({});
        }
    }, [filterValue]);

    const applyFilter = (filterValue: any) => {
        getRatingSummary(filterValue);
    }

    const getRatingSummary = (param: any) => {
        setOnSubmitLoading(true);
        let params: any;
        if (param) {
            params = { branch_id: branchDS?.branch_id, ...param };
        } else {
            params = { branch_id: branchDS?.branch_id };
        }
        try {
            setTimeout(() => {
                reviewAPI.getRatingSummary(params, (msg: any, resp: any) => {
                    setRatingSummary(resp.data);

                }, (err: any, resp: any) => {
                    toast.error(resp?.detail?.message);
                });
                setOnSubmitLoading(false);
            }, 3000);

        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    };

    const formatDate = (date: string) => {
        return moment(date).format('DD MMM');
    }

    const generateDynamicTicks = (data: any) => {
        if (!data || data.length === 0) return [0];  // Return 0 if no data

        const maxRating = Math.max(...data.map((d: { avg_rating: number }) => d.avg_rating));  // Get the max rating
        const step = 0.5;  // Define step size for ticks
        const ticks = [];

        // Generate ticks starting from 0 and incrementing by step size
        for (let i = 0; i <= maxRating; i += step) {
            ticks.push(parseFloat(i.toFixed(1)));  // Ensure one decimal place
        }

        return ticks;
    }

    return (
        <div className="flex flex-col">
            <div className="flex justify-between items-center p-2 rounded-md">
                <h1 className="text-base font-semibold text-gray-600">
                    Rating OverTime

                </h1>
                {/* <button className="bg-gray-400 text-lg text-gray-500 font-semibold bg-white py-2 px-4 rounded-md hover:bg-white transition-all duration-300">
                    Export
                </button> */}

            </div>
            <hr className="border-gray-300 mt-[5px]" />
            <div className="flex flex-col relative">
                <p className="w-32 h-32 flex text-2xl font-semibold text-gray-600 -mt-[14px] mb-4">
                    {ratingSummary?.total_rating_count}
                </p>
            </div>

            <div className="-mt-[75px]">

                {ratingSummary?.ratings_by_date?.length > 0 && (<div>
                    <ResponsiveContainer width={"100%"} height={300}>
                        <AreaChart
                            width={200}
                            height={60}
                            data={ratingSummary?.ratings_by_date}
                            margin={{
                                top: 5,
                                right: 0,
                                left: 0,
                                bottom: 5
                            }}
                        >
                            <XAxis dataKey="date" tickFormatter={formatDate} />
                            <YAxis domain={[0, 'dataMax']}
                                tickFormatter={(value) => value.toFixed(1)}
                                ticks={generateDynamicTicks(ratingSummary?.ratings_by_date)} />
                            <Tooltip />
                            <Legend />
                            <Area type="monotone" dataKey="rating_count" stroke="#EED202" fill="#EED202" />
                        </AreaChart>
                    </ResponsiveContainer>
                </div>)}
            </div>
        </div>
    );
};

export default OverallRating;
